<template>
  <div class="beikostworkshop">
    <h1>Beikostworkshop</h1>
    <p>Der Beginn der Beikost ist ein spannender Meilenstein in der Entwicklung eures Kindes – und oft mit vielen Fragen verbunden:</p>
    <ul>
      <li>Wann ist mein Baby bereit für Beikost?</li>
      <li>Brei oder Baby led weaning – was passt zu uns?</li>
      <li>Was darf mein Baby essen (und was nicht)?</li>
      <li>Verschlucken: Wie kann ich mein Baby schützen?</li>
      <li>Wie sind die Empfehlungen zur Allergieprävention?</li>
      <li>Ab wann darf mein Baby Wasser trinken?</li>
      <li>Was tun, wenn mein Baby nichts essen will?</li>
    </ul>
    <p>In diesem Workshop gehen wir auf all diese Fragen ein und besprechen praxisnah, wie ihr euren Beikoststart entspannt und selbstbewusst gestalten könnt – 
    <strong>ganz ohne Druck und mit viel Freude am gemeinsamen Essen.</strong></p>
    <p>Am Ende bleibt selbstverständlich Zeit für eure individuellen Fragen. Bitte habt jedoch Verständnis, dass eine ausführliche <router-link to="/beikostberatung">Einzelberatung</router-link> in diesem Rahmen nicht möglich ist.</p>
    <p>Die <strong>Kosten</strong> betragen 30 € pro Person bzw. 45 € pro Paar.</p>
    <p>Kurse finden <strong>online und vor Ort in Metternich</strong> statt (da dürft ihr eure Babies natürlich mitbringen!). Aktuelle Termine findet ihr <router-link to="/">hier</router-link>.</p>
    <p>
      Falls du dich zu einem <strong>Kurs anmelden</strong> möchtest oder noch Fragen hast, schreib gerne eine kurze Mail an
      <a href="mailto:info@maikes-familienbegleitung.de">info@maikes-familienbegleitung.de</a>
    </p>
    <p>
      <strong>Ihr seid eine Gruppe</strong> und wünscht euch einen Kurs ganz bequem bei euch im Wohnzimmer? Kein Problem! Meldet euch einfach, wir finden einen Termin!
    </p>
  </div>
</template>

<script>
export default {
  name: 'Beikostworkshop'
}
</script>

<style scoped>
.beikostworkshop {
}
</style>